@if (statLastDoc === true) {
  <div [ngClass]="isDesktop === true ? 'margin' : 'margin scroll-table'">
    <p-table
      #dt
      selectionMode="single"
      [columns]="listColumns"
      [value]="resultDisplay"
      [rows]="nbRow"
      [paginator]="false"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      (onRowSelect)="onRowSelect($event)"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right font-bold">{{'Last_DocV' | translate}}</span>
        </span>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.field"
                    [ngClass]="{
                        'width-col-date': col.field === 'dateview',
                        'width-auto': col.field === 'docName'
                    }"
              >
              <p-sortIcon [field]="col.field"></p-sortIcon>
              <span>
                {{ col.header }}
              </span>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData" class="table-row">
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto"
                [ngClass]="{
                    cursornot: rowData['acces'] === false
                }"
              >
                @switch (col.field) {
                  @case ('acces') {
                    <div class="left">
                      @if (rowData[col.field] === true) {
                        <i
                          class="icons8-visible md-18"
                          pTooltip="{{'Access_OK' | translate}}"
                          tooltipPosition="top"
                        ></i>
                      }@else {
                        <i
                          class="icons8-invisible md-18"
                          pTooltip="{{'Access_KO' | translate}}"
                          tooltipPosition="top"
                          >
                        </i>
                      }
                    </div>
                  }
                  @case ('dateview') {
                    {{ rowData[col.field] | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  }
                  @default {
                    {{ rowData[col.field] }}
                  }
                }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td>{{'Empty_1' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
